import { render } from "./Inventory_AvailableItemsOverride_Dialog.vue?vue&type=template&id=64363cab&scoped=true&ts=true"
import script from "./Inventory_AvailableItemsOverride_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_AvailableItemsOverride_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_AvailableItemsOverride_Dialog.vue?vue&type=style&index=0&id=64363cab&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64363cab"]])

export default __exports__